import React from 'react';
import './CrcFooter.css';

const AppFooter = (props) => {

  let year = new Date().getFullYear();
  return (
    <footer className="crc-footer">
      &copy; {year} Cleveland Clinic. All Rights Reserved.
    </footer>
  )
};

export default AppFooter;



// WEBPACK FOOTER //
// ./src/crc/components/crc-footer/CrcFooter.js